"use client";

import { Card, CardContent } from "../UI/card";
import {
  TrendingUp,
  BarChart3,
  Users,
  DollarSign,
} from "lucide-react";
import JiraSidebar from "./JiraSidebar";

export default function ReportsPage() {
  const summaryCards = [
    {
      title: "Project Overview",
      desc: "Status and progress summary",
      icon: TrendingUp,
      color: "text-green-600",
    },
    {
      title: "Sprint Velocity",
      desc: "Team performance metrics",
      icon: BarChart3,
      color: "text-blue-600",
    },
    {
      title: "Team Workload",
      desc: "Resource allocation",
      icon: Users,
      color: "text-purple-600",
    },
    {
      title: "Time & Cost",
      desc: "Budget and hours analysis",
      icon: DollarSign,
      color: "text-orange-500",
    },
  ];

  const completionData = [
    { label: "TECH", value: 45 },
    { label: "START", value: 25 },
    { label: "CRM", value: 60 },
    { label: "ECOM", value: 10 },
  ];

  const issueStatus = [
    { label: "Backlog", count: 1 },
    { label: "Todo", count: 1 },
    { label: "In Progress", count: 3 },
    { label: "In Review", count: 1 },
    { label: "Done", count: 2 },
    { label: "Cancelled", count: 0 },
  ];

  const issuePriority = [
    { label: "Lowest", count: 0 },
    { label: "Low", count: 0 },
    { label: "Medium", count: 2 },
    { label: "High", count: 5 },
    { label: "Highest", count: 0 },
  ];

  return (
    <div className="flex flex-1 bg-gray-50">
      {/* ================= DASHBOARD SIDEBAR ================= */}
      <JiraSidebar activeItem="reports" />

      {/* ================= MAIN CONTENT ================= */}
      <main className="flex-1 p-6 space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-2xl font-semibold">Reports</h1>
          <p className="text-sm text-muted-foreground">
            Project analytics and insights
          </p>
        </div>

        {/* Summary Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {summaryCards.map((item, i) => (
            <Card key={i} className="rounded-2xl">
              <CardContent className="p-5 flex gap-4 items-center">
                <item.icon className={`w-8 h-8 ${item.color}`} />
                <div>
                  <p className="font-medium">{item.title}</p>
                  <p className="text-sm text-muted-foreground">
                    {item.desc}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Project Completion Trend */}
        <Card className="rounded-2xl">
          <CardContent className="p-6">
            <h2 className="font-semibold mb-4">
              Project Completion Trend
            </h2>

            <div className="flex items-end gap-4 h-32">
              {completionData.map((item, i) => (
                <div key={i} className="flex-1 text-center">
                  <div
                    className="bg-green-500 rounded-md mx-auto"
                    style={{ height: `${item.value}%` }}
                  />
                  <p className="text-xs mt-2 font-medium">
                    {item.label}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {item.value}%
                  </p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Bottom Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Issues by Status */}
          <Card className="rounded-2xl">
            <CardContent className="p-6">
              <h2 className="font-semibold mb-4">
                Issues by Status
              </h2>

              {issueStatus.map((item, i) => (
                <div key={i} className="mb-3">
                  <div className="flex justify-between text-sm mb-1">
                    <span>{item.label}</span>
                    <span>{item.count}</span>
                  </div>
                  <div className="h-2 bg-gray-200 rounded">
                    <div
                      className="h-2 bg-green-500 rounded"
                      style={{ width: `${item.count * 15}%` }}
                    />
                  </div>
                </div>
              ))}
            </CardContent>
          </Card>

          {/* Issues by Priority */}
          <Card className="rounded-2xl">
            <CardContent className="p-6">
              <h2 className="font-semibold mb-4">
                Issues by Priority
              </h2>

              {issuePriority.map((item, i) => (
                <div key={i} className="mb-3">
                  <div className="flex justify-between text-sm mb-1">
                    <span>{item.label}</span>
                    <span>{item.count}</span>
                  </div>
                  <div className="h-2 bg-gray-200 rounded">
                    <div
                      className="h-2 bg-orange-400 rounded"
                      style={{ width: `${item.count * 15}%` }}
                    />
                  </div>
                </div>
              ))}
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  );
}
